import { ApiQuestion, Question } from '../types/questionnaire.types';

export class QuestionAdapter {
  /**
   * Converte a resposta da API para o formato Question[]
   */
  static fromApi(apiQuestions: ApiQuestion[]): Question[] {
    return apiQuestions
      .filter((q) => !q.isDeleted)
      .map((apiQuestion) => this.convertQuestion(apiQuestion));
  }

  private static convertQuestion(apiQuestion: ApiQuestion): Question {
    const baseQuestion: Question = {
      id: apiQuestion.id,
      type: apiQuestion.type,
      question: apiQuestion.question,
      required: apiQuestion.required,
    };

    // Adiciona answers se existirem e não estiverem vazios
    if (apiQuestion.answers && apiQuestion.answers.length > 0) {
      baseQuestion.answers = apiQuestion.answers;
    }

    // Adiciona matrixRows se existirem e não estiverem vazios
    if (apiQuestion.matrixRows && apiQuestion.matrixRows.length > 0) {
      baseQuestion.matrixRows = apiQuestion.matrixRows;
    }

    // Adiciona matrixColumns se existirem e não estiverem vazios
    if (apiQuestion.matrixColumns && apiQuestion.matrixColumns.length > 0) {
      baseQuestion.matrixColumns = apiQuestion.matrixColumns;
    }

    // Adiciona maxLength se existir (para essay)
    if (apiQuestion.maxLength !== undefined) {
      baseQuestion.maxLength = apiQuestion.maxLength;
    }

    // Adiciona maxSelections se existir (para multiple_choice_checkbox)
    if (apiQuestion.maxSelections !== undefined) {
      baseQuestion.maxSelections = apiQuestion.maxSelections;
    }

    return baseQuestion;
  }

  /**
   * Exemplo de uso com dados mockados
   */
  static example() {
    const apiResponse: ApiQuestion[] = [
      /* sua resposta de API aqui */
    ];

    const questions = this.fromApi(apiResponse);
    return questions;
  }
}
